import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Counter } from "@/components/motion";

const STATS = [
  { to: 8, suffix: "+", label: "anni di esperienza" },
  { to: 11, suffix: "", label: "aree di competenza" },
  { to: 15, suffix: "+", label: "settori in cui operiamo" },
];

export const PercheSection = () => (
  <section className="py-16 sm:py-36" data-testid="perche-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start">
      <Reveal className="lg:col-span-5">
        <p className="eyebrow mb-5">Perché Idea 360</p>
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-[1.1]"
          style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }}
          data-testid="perche-h2"
        >
          Un solo team, <span className="text-[#FACC15]">dentro e accanto</span> alla tua azienda
        </h2>
      </Reveal>

      <div className="lg:col-span-7 lg:pt-10">
        <Reveal delay={0.1}>
          <p className="text-white/70 text-lg sm:text-xl leading-relaxed">
            Idea 360 Consulting è un team di professionisti con oltre 8 anni di esperienza in
            settori diversi tra loro: non consulenti che danno un parere e se ne vanno, ma un
            partner operativo e strategico che resta al tuo fianco, dalla decisione
            all'esecuzione.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-3 gap-4 sm:gap-6 border-t border-[#1f1f1f] pt-8" data-testid="perche-stats">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={0.15 + i * 0.1}>
              <p
                className="text-3xl sm:text-5xl font-bold text-[#FACC15] leading-none"
                style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.03em" }}
              >
                <Counter to={s.to} suffix={s.suffix} />
              </p>
              <p className="mt-3 text-white/55 text-xs sm:text-sm tracking-wide">{s.label}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.35}>
          <Link
            to="/chi-siamo"
            className="mt-10 btn-outline-yellow inline-flex items-center gap-2 group"
            data-testid="perche-cta"
          >
            Scopri chi siamo
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);

export default PercheSection;
